module.exports = __webpack_public_path__ + "img/AW.7f8e9eb0.png";